import {Injectable} from '@angular/core';
import {ApiService} from "../api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {SocietyInformation} from "@core/shared/models/society/society-information";
import {Society} from "@core/shared/models/society";

@Injectable({
    providedIn: 'root'
})
export class SocietyInformationService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {
    }

    public getItemAPI(societyId: number, params?: string[]): Observable<SocietyInformation> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${societyId}/information`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<SocietyInformation>(url, {
            headers: headers
        });
    }

    public updateItemAPI(societyId: number, data: object[]): Observable<SocietyInformation> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.patch<SocietyInformation>(`${this._apiService.getApiUrl(false, true)}/societies/${societyId}/information`, data,{
            headers: headers
        });
    }

    public getSummaryItemAPI(societyId: number, data: object): Observable<Society> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<Society>(`${this._apiService.getApiUrl(false, true)}/societies/${societyId}/information/summary`, data,{
            headers: headers
        });
    }
}
